import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductTile } from '@as/cotopaxi';
import { ProductTypes } from '@as-react/common-types';
import { Box, Price, TextAlpha } from '@yonderland/andes-react';
import { usePriceProps } from '../../../hooks/usePriceProps';
const IMAGE_SIZE = {
    mobile: { width: 88, height: 130 },
    tablet: { width: 64, height: 96 },
};
export const AddToBasketPopupTile = ({ brand, description, image, productType, title, enablePriceReference, product, }) => {
    var _a;
    const priceInformation = product
        ? {
            hasDiscount: Boolean(product.productHasDiscount),
            prices: ((_a = product.prices) === null || _a === void 0 ? void 0 : _a.SELL)
                ? product.prices
                : {
                    SELL: { original: product.price, priceState: 'NOW' },
                    STD: { original: product.previousPrice || product.price, priceState: 'WAS' },
                    LOWEST: { original: product.lowestPrice },
                },
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation,
        enablePriceReference,
        dynamicSavingsInformation: {
            productDiscountAmount: product === null || product === void 0 ? void 0 : product.productDiscountAmount,
            productDiscountPercentage: product === null || product === void 0 ? void 0 : product.productDiscountPercentage,
        },
    });
    return (_jsxs(ProductTile, { variant: "horizontal", product: { image, brand, title, alt: title }, children: [_jsx(ProductTile.Area, { area: "primary", children: _jsx(ProductTile.Image, { width: IMAGE_SIZE.mobile.width, height: IMAGE_SIZE.mobile.height, containerOptions: {
                        mobile: {
                            spacing: { marginRight: 1.5 },
                            width: IMAGE_SIZE.mobile.width,
                            height: IMAGE_SIZE.mobile.height,
                        },
                        tablet: {
                            spacing: { marginRight: 3 },
                            width: IMAGE_SIZE.tablet.width,
                            height: IMAGE_SIZE.tablet.height,
                        },
                    } }) }), _jsxs(ProductTile.Area, { area: "secondary", children: [_jsx(ProductTile.Title, { emphasizeTitle: productType === ProductTypes.E_VOUCHER, brandOnTheSameLine: true, containerOptions: {
                            mobile: { spacing: { marginBottom: productType === ProductTypes.E_VOUCHER ? 0 : 0.5 } },
                            tablet: { spacing: { marginBottom: 1 } },
                        } }), Boolean((productType === ProductTypes.PRODUCT || productType === ProductTypes.E_VOUCHER) && description) && (_jsx(Box, { paddingBlockEnd: {
                            xs: '0.5',
                            md: productType === ProductTypes.E_VOUCHER ? '0.5' : '4',
                        }, children: _jsx(TextAlpha, { as: "span", variant: "bodyS", color: "subtle", children: description }) })), priceProps && Boolean(priceProps.priceActual) && _jsx(Price, Object.assign({}, priceProps))] })] }));
};
